import { isEmptyString } from '@racemap/utilities/functions/utils';
import { isDefined } from '@racemap/utilities/functions/validation';
import type { StoreApi } from 'zustand';
import type { State } from '../reducers';
import { filterTrackers } from './trackers_helper';
import type { TrackersState } from './trackers_reducers';

export const createTrackerGetters = (
  get: StoreApi<State>['getState'],
): TrackersState['trackers']['getter'] => ({
  selectedTracker: (selectionId) => {
    const selection = get().trackers.selectedTrackerIds[selectionId];
    const items = get().trackers.items;

    return Array.from(selection)
      .map((s) => items.get(s))
      .filter(isDefined);
  },
  filteredTrackers: () => {
    const { items, searchValue, filterSet, trackerTags } = get().trackers;

    const filtered = filterTrackers(
      items,
      searchValue,
      filterSet,
      get().users.currentUserId,
      trackerTags,
    );

    // make most recently added trackers appear first
    return [...filtered].reverse();
  },
  inspectedTracker: () => {
    const trackerId = get().trackers.inspectedTrackerId;
    const items = get().trackers.items;
    if (trackerId == null) return null;

    return items.get(trackerId.toHexString()) || null;
  },
  sampleTrackers: () => {
    const sampleIds = get().trackers.sampleTrackerIds;
    const items = get().trackers.items;

    return Array.from(sampleIds)
      .map((s) => items.get(s))
      .filter(isDefined);
  },
  countSearchedTrackers: () => {
    const { searchValue } = get().trackers;
    if (isEmptyString(searchValue)) return 0;

    return filterTrackers(get().trackers.items, searchValue, new Set<string>(), null).length;
  },
});
